<template lang="html">
  <div class="circle-wrapper">
    <div
      class="pair pair_stacked pair_circle border-circle border-colored border-colored-2x text-center">
      <div class="pair__coef__container">
        <!--.pair__coef(v-resize-text="resizeOptions")-->
        <div class="pair__coef fittext" :style="fittextStyle" ref="balanceText">
          {{ moneyFormat(balance, currency) }}
          <!--fitty(:options="fittyOptions").fitty-balance
          //template(v-slot:content) {{balance|money(currency)}}

          -->
        </div>
      </div>
      <span class="pair__name">{{ publicCurrency }}</span>
      <div><span class="currency-crypto-system-icon" v-if="showCryptoSystemIcon"
                 :class="cryptoSystemBadgeClass">{{ networkTitle }}</span></div>
      <span class="badge badge_backdrop-lg">
      <template v-if="publicCurrency == 'USDC'"><img src="./icons/usdcoin.svg" width="28"
                                                          height="28"/></template>
      <template v-else><span
        class="cap-icon currency__sign currency__sign_colored currency__sign_circle"
        :class="currencyIconClass"></span>
        <!--.currency__sign_green-->
      </template></span>
    </div>
  </div>

</template>

<script lang="ts" setup>
import Vue, {computed} from 'vue';
// import { Component, Prop } from 'vue-property-decorator';
// import ResizeText from 'vue-resize-text';
// import { UsdtNetworkTitles, UsdtNetworkType } from '../../../../../models/finance/crypto';
import {MoneyFormatFilter} from '@/models/filters/money';
import {CurrencyCode} from "@/models/core/currency";
import {UsdtNetworkTitles} from "@/models/finance/crypto";

const moneyFormat = MoneyFormatFilter;

const props = defineProps({
  currency: {
    type: String,
    required: true,
  },
  balance: {
    // type: [Number, String],
    required: true,
  },
  usdtCryptoSystem: {
    type: String,
    default: null,
  },
})

const balanceText = computed(() => {
  return `${MoneyFormatFilter(props.balance, props.currency as CurrencyCode)}`;
})

const fittextStyle = computed(() => {
  const fontSize = Math.round(Math.min(20, (200 / balanceText.value.length))) - 1;
  return {
    'font-size': `${fontSize}px`,
    // 'margin-top': (28 - fontSize) + 'px',
    // 'padding-top': (18 - fontSize) + 'px'
  };
})

const publicCurrency = computed(() => {
  return props.currency === CurrencyCode.USDTt ? CurrencyCode.USDT : props.currency;
})

const showCryptoSystemIcon = computed(() => {
  return props.usdtCryptoSystem && ((props.currency === CurrencyCode.USDT)
    || (props.currency === CurrencyCode.USDTt));
})

const cryptoSystemBadgeClass = computed(() => {
  if (!props.usdtCryptoSystem) return {};

  const system = props.usdtCryptoSystem.toLowerCase();

  return {
    [`currency-crypto-system-icon__${system}`]: true,
  };
})

const networkTitle = computed(() => {
  if (!props.usdtCryptoSystem) return null;

  return props.usdtCryptoSystem in UsdtNetworkTitles ? UsdtNetworkTitles[props.usdtCryptoSystem] : null;
})

const currencyIconClass = computed(() => {
  const cur = publicCurrency.value.toLowerCase();
  return {
    [`currency-cap-icon-${cur}`]: true,
    [`currency-sign__${cur}`]: true,
    'cap-icon-dollar': props.currency === CurrencyCode.USD,
    'cap-icon-euro': props.currency === CurrencyCode.EUR,
    'cap-icon-rub': props.currency === CurrencyCode.RUR,
    'cap-icon-bitcoin': props.currency === CurrencyCode.BTC,
    'capitalist-icon-ethereum': props.currency === CurrencyCode.ETH,
    'capitalist-icon-usdcoin': props.currency === CurrencyCode.USDC,
    'capitalist-icon-tether': (props.currency === CurrencyCode.USDT) || (props.currency === CurrencyCode.USDTt),
  };
})
//
// @Component({
//   name: 'currency-balance-summary-circle',
//   filters: {
//     money: MoneyFormatFilter,
//   },
//   directives: {
//     ResizeText,
//   },
// })
// export default class CurrencyBalanceSummaryCircle extends Vue {
//   @Prop({ required: true, default: CurrencyCode.USD })
//   currency!: CurrencyCode
//
//   @Prop({ default: 0 })
//   balance!: number
//
//   @Prop({ default: UsdtNetworkType.Ethereum })
//   usdtCryptoSystem!: UsdtNetworkType
//
//   get balanceText() {
//     return `${MoneyFormatFilter(this.balance, this.currency)}`;
//   }
//
//   get fittextStyle() {
//     const fontSize = Math.round(Math.min(20, (200 / this.balanceText.length))) - 1;
//     return {
//       'font-size': `${fontSize}px`,
//       // 'margin-top': (28 - fontSize) + 'px',
//       // 'padding-top': (18 - fontSize) + 'px'
//     };
//   }
//
//   mounted() {
//     // let t          = $(this),
//     //     width      = t.data("width") * 2,
//     //     characters = t.html().length,
//     //     size       = width/characters;
//     //
//     // $(this).css('font-size', `${size}vw`);
//   }
//
//   get fittyOptions() {
//     return {
//       minSize: 11,
//       maxSize: 20,
//     };
//   }
//
//   get resizeOptions() {
//     return {
//       minFontSize: '15px',
//       maxFontSize: '40px',
//       ratio: 0.7,
//     };
//   }
//
//   get showCryptoSystemIcon() {
//     return this.usdtCryptoSystem && ((this.currency === CurrencyCode.USDT)
//       || (this.currency === CurrencyCode.USDTt));
//   }
//
//   get cryptoSystemBadgeClass() {
//     if (!this.usdtCryptoSystem) return {};
//
//     const system = this.usdtCryptoSystem.toLowerCase();
//
//     return {
//       [`currency-crypto-system-icon__${system}`]: true,
//     };
//   }
//
//   get networkTitle() {
//     if (!this.usdtCryptoSystem) return null;
//
//     return this.usdtCryptoSystem in UsdtNetworkTitles ? UsdtNetworkTitles[this.usdtCryptoSystem] : null;
//   }
//
//   get publicCurrency() {
//     return this.currency === CurrencyCode.USDTt ? CurrencyCode.USDT : this.currency;
//   }
//
//   get currencyIconClass() {
//     const cur = this.publicCurrency.toLowerCase();
//     return {
//       [`currency-cap-icon-${cur}`]: true,
//       [`currency-sign__${cur}`]: true,
//       'cap-icon-dollar': this.currency === CurrencyCode.USD,
//       'cap-icon-euro': this.currency === CurrencyCode.EUR,
//       'cap-icon-rub': this.currency === CurrencyCode.RUR,
//       'cap-icon-bitcoin': this.currency === CurrencyCode.BTC,
//       'capitalist-icon-ethereum': this.currency === CurrencyCode.ETH,
//       'capitalist-icon-usdcoin': this.currency === CurrencyCode.USDC,
//       'capitalist-icon-tether': (this.currency === CurrencyCode.USDT) || (this.currency === CurrencyCode.USDTt),
//     };
//   }
// }
</script>

<style scoped lang="less">
@import "../../../../../assets/capitalist-config";

.fittext {
  text-align: center;
  line-height: 1em;
}

.currency-sign {
  &__ {
    &usd {
      background: @colorCurrencyUSD;
    }

    &eur {
      background: @colorCurrencyEUR;
    }

    &rur {
      background: @colorCurrencyRUR;
    }

    &btc {
      background: @colorCurrencyBTC;
    }

    &eth {
      background: @colorCurrencyETH;
    }

    &usdt {
      background: @colorCurrencyUSDT;
    }

    &usdc {
      background: @colorCurrencyUSDC;
    }

    &usdtt {
      background: @colorCurrencyUSDT;
    }

    &__crypto_network__ {
      &ethereum {

      }

      &tron {

      }
    }
  }
}

.pair__coef {
  white-space: nowrap;
  //overflow: hidden;
  //height: 21px;
}

.pair__name {
  margin-top: 6px;
  line-height: 1em;
  font-size: 16px;
}

.pair__coef__container {

  padding: 0 5px;
  margin: 0;
}

.currency__sign_circle {
  display: grid;
  padding: 0;
  justify-content: center;
  align-items: center;

  &.currency-sign__usdt {
    line-height: 13px;
    font-size: 15px;
  }
}

.currency-crypto-system-icon {
  display: inline-block;
  font-size: 80%;
  background: #777777;
  border-radius: 3px;
  padding: 2px 4px;
  font-weight: bold;
  color: #fff;
  line-height: 1em;

  &.currency-crypto-system-icon__ {
    &ethereum {
      background: @colorCryptoUsdtErc20;
    }

    &tron {
      background: @colorCryptoUsdtTrc20;
    }
  }
}
</style>
